import { z } from "zod";

export const userOrganizationRolesKey = "userOrganizationRoles" as const;

export const getUserOrganizationRolesQueryKey = (userId: number | undefined, organizationId: number | undefined) => [
    userOrganizationRolesKey,
    userId,
    organizationId,
];

export type UserOrganizationRoles = {
    userId?: number;
    organizationId?: number;
    roles: string[];
};

export const UserOrganizationRolesSchema: z.ZodSchema<UserOrganizationRoles> = z
    .object({
        userId: z.number().optional(),
        organizationId: z.number().optional(),
        roles: z.array(z.string()),
    })
    .passthrough();

export type UserOrganizationRolesPayload = {
    roles: string[];
};
